// #tag: FIREBASE WEB SDK INITIALIZER
// #purpose: Configures and initializes Firebase client app instance with project credentials and fallback settings.
import { getApps, initializeApp, type FirebaseApp, type FirebaseOptions } from 'firebase/app';

const DEFAULT_FIREBASE_CONFIG: FirebaseOptions = {
  apiKey: 'AIzaSyCoKUz3KNeSTHw_5bHdlYUN1jwJn1tVc9s',
  authDomain: 'device-streaming-2ecc279a.firebaseapp.com',
  projectId: 'device-streaming-2ecc279a',
  storageBucket: 'device-streaming-2ecc279a.firebasestorage.app',
  messagingSenderId: '806024977187',
  appId: '1:806024977187:web:f7bae5474d865637e50a96',
};

export const firebaseConfig: FirebaseOptions = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || DEFAULT_FIREBASE_CONFIG.apiKey,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || DEFAULT_FIREBASE_CONFIG.authDomain,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || DEFAULT_FIREBASE_CONFIG.projectId,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || DEFAULT_FIREBASE_CONFIG.storageBucket,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || DEFAULT_FIREBASE_CONFIG.messagingSenderId,
  appId: process.env.REACT_APP_FIREBASE_APP_ID || DEFAULT_FIREBASE_CONFIG.appId,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const isFirebaseConfigured = Boolean(
  firebaseConfig.apiKey &&
    firebaseConfig.authDomain &&
    firebaseConfig.projectId &&
    firebaseConfig.appId,
);

let app: FirebaseApp | null = null;

// #tag: FIREBASE APP INSTANCE GETTER
// #purpose: Retrieves singleton Firebase app instance or instantiates new app from configuration.
export function getFirebaseApp(): FirebaseApp | null {
  if (!isFirebaseConfigured) return null;
  if (!app) app = getApps().length ? getApps()[0]! : initializeApp(firebaseConfig);
  return app;
}
